import { DashboardFormWrapper } from '../../dashboard';
import { CompanyPage, CompanyHeader, CompanyForm } from '../CompanyFormComponents';
import { RoleGuard } from '../../../routes';

export const YardsAdd = () => {
  return (
    <RoleGuard roles={['SUPER_ADMIN']}>
      <CompanyPage>
        <CompanyHeader belongsTo={'YARD'} />
        <DashboardFormWrapper flow={'row'}>
          <CompanyForm belongsTo={'YARD'} />
          <CompanyHeader belongsTo={'YARD'} showOnlySubmit />
        </DashboardFormWrapper>
      </CompanyPage>
    </RoleGuard>
  );
};
